/**
 * @param {object | null | undefined} error
 * @returns {boolean}
 */
export function isPdfRenderCancelled(error) {
  if (error == null || typeof error !== "object") {
    return false;
  }
  return "name" in error && error.name === "RenderingCancelledException";
}
